import React from 'react';
import PropTypes from 'prop-types';


const IfNonMemoed = ({ condition, children = null, alt = null }) => {
    return condition ? children : alt;
};

const If = React.memo(IfNonMemoed);

If.propTypes = {
    condition: PropTypes.any.isRequired,
}

export default If;